import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.inspection-participant-card {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  background: ${dt('inspectionParticipantCard.background')};
  border-radius: ${dt('inspectionParticipantCard.borderRadius')};
  box-shadow: ${dt('inspectionParticipantCard.boxShadow')};
  padding: ${dt('inspectionParticipantCard.padding')};
  gap: ${dt('inspectionParticipantCard.gap')};
}`;
